module.exports = __webpack_public_path__ + "c0c8915e7d88fc15e6d312647c837e7d.pdf";